import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Form, Row, Table, Modal } from "react-bootstrap";
import ExportApi from "../api/ExportApi";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { useAuthUser } from "../customHooks/useAuthUser";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import { getExpDate, getRemainingDays } from "../helper/utils";
import SortSvg from "../assets/svg/SortSvg";
import EditSvg from "../assets/svg/editSvg";
import CustomModal from "../shared/CustomModal";
import SharedTable from "../shared/sharedTable";
import { PRODUCT_TYPES } from "../helper/constant";
import SharedOffcanvas from "../shared/sharedOffcanvas";
import moment from "moment";

export default function BuyingTab() {
  const loggedInUser = useAuthUser();
  let imageUrl = process.env.REACT_APP_IMAGEBASEURL;
  const navigate = useNavigate();
  const [bidData, setBidData] = useState([]);
  const [allBidData, setAllBidData] = useState([]);
  const [initialLoader, setInitialLoader] = useState(false)
  const [descriptionindex, setdescriptionindex] = useState();
  const [descriptionindex1, setdescriptionindex1] = useState(null);
  const [currentSortOrder, setCurrentSortOrder] = useState(1);
  const [currentSortKey, setCurrentSortKey] = useState(null);
  const [loader, setLoader] = useState(0);
  const [selectedData, setSelectedData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  //Filter State
  const [conditionKey, setconditionKey] = useState([]);
  const [chipsetKey, setchipsetKey] = useState([]);
  const [brandKey, setbrandKey] = useState([]);
  const [seriesKey, setseriesKey] = useState([]);
  const [modalKey, setmodalKey] = useState([]);
  const [FilterList, setFilterList] = useState();
  const [chipsetShow, setChipsetShow] = useState(false);
  const [seriesShow, setSeriesShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [condition1, setcondition1] = useState([]);
  const [brandShow, setBrandShow] = useState(false);
  const [chipset, setchipset] = useState([]);
  const [condition, setcondition] = useState([]);
  const [brand, setbrand] = useState([]);
  const [series, setseries] = useState([]);
  const [model, setmodel] = useState([]);
  const [selectCheckBox, setSelectCheckBox] = useState(false);
  const [batchCount, setBatchCount] = useState();
  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const [batchData, setBatchData] = useState([]);
  const [hideBatchStatus, setHideBatchStatus] = useState(false);
  const [bidlistStatus, setBidListStatus] = useState(false);
  const [showUnbatchLoader, setShowUnbatchLoader] = useState(false)
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);
  const [alreadyCreatedBatch, setAlreadyCreatedBatch] = useState(false);
  const [expiration, setExpiration] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);

  const [updateBid, setUpdateBid] = useState(null);

  const [allLoader, setAllLoaders] = useState({
    batching: false,
    unBatching : false,
    makeInactive : false,
    makeActive : false
  })

  const columns = [
    {
      name: () => {
        return (
          <span onClick={(e) => e.stopPropagation()} className="d-flex flex-row gap-1">
            <Form.Check>
              <Form.Check.Input
                type="checkbox"
                checked={
                  allBidData.length > 0 &&
                  selectedIds.length === allBidData.length
                }
                onChange={handleSelectAll}
                style={{ cursor: "pointer" }}
              />
              <Form.Check.Label style={{ cursor: "pointer" }}>
                Select All
              </Form.Check.Label>
            </Form.Check>
          </span>
        )
      },
      render: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()} style={{ cursor: "pointer" }}>
            <Form.Check className="d-inline">
              <Form.Check.Input
                type="checkbox"
                checked={selectedIds.includes(row?._id)}
                onChange={(e) =>
                  handleCheck(e.target.checked, row?._id)
                }
                style={{ cursor: "pointer" }}   // 👈 fixes the box
              />
            </Form.Check>
          </div>
        )
      }
    },
    {
      name: "Created Date",
      render: (row) => {
        const localDateStr = row.createdAt
          ? moment(row.createdAt).local().format("DD/MM/YY")
          : "-";

        return <div>{localDateStr}</div>;
      },
    },
    {
      name: "Product",
      render: (row) => {
        return (
          <div className="d-flex flex-row justify-content-center align-items-center">
            <div style={{ width: "50px", height: "50px" }}>
              <img
                src={
                  row?.productId?.image[0]?.startsWith("http")
                    ? row?.productId?.image[0]
                    : `${imageUrl}${row?.productId?.image[0]}`
                }
                style={{ width: "100%", height: "100%" }}
                onClick={() =>
                  navigate(
                    `/product/${row?.productId?.slug}`
                  )
                }
              />
            </div>
            <div class="position-relative ms-1">
              <span className="d-block text-center">
                {PRODUCT_TYPES[row?.productId?.type]}
              </span>
            </div>
          </div>
        )
      }
    },
    {
      name: "Chipset",
      render: (row) => {
        return (
          <div>  {row?.productId?.chipset}</div>
        )
      }
    },
    {
      name: "Expiration(Remaining days)",
      width: "150px",
      render: (row) => {
        return (
          <div style={{ width: "30px" }}>
            <span>
              {getRemainingDays(row?.createdAt, row?.expirationTime)}
            </span>
          </div>
        )
      }
    },
    {
      name: "Expiration Date",
      width: "100px",
      render: (row) => {
        return (
          <div style={{ width: "30px" }}>
            <span>
              {getExpDate(row?.createdAt, row?.expirationTime)}
            </span>
          </div>
        )
      }
    },
    {
      name: "Bid Status",
      width: "100px",
      render: (row) => {
        return (
          <div style={{ width: "30px" }}>
            {
              getRemainingDays(row?.createdAt, row?.expirationTime) <= 0 ? (
                <span className="text-danger">
                  Expired
                </span>
              ) : row?.bidStatus ? (
                <span className="text-success">
                  Active
                </span>
              ) : (
                 <span className="text-warning">
                  Inactive
                </span>
              )
            }

          </div>
        )
      }
    },
    {
      name: () => {
        return (
          <span className="d-flex flex-row gap-1 align-items-center">
            <span>
              Spread
            </span>
            <ReactTooltip
              className="custom-tooltip"
              anchorId={`app-batch-spread-tab`}
              place="bottom"
              clickable={true}
              closeOnScroll={false}
              content={
                <div
                  dangerouslySetInnerHTML={{
                    __html: "<p>Spread = Lowest Ask - Your Bid</p>",
                  }}
                />
              }
            />
            <span style={{ cursor: "pointer" }}>
              <QuestionMarkSvg id={`app-batch-spread-tab`} />
            </span>
          </span>
        )
      },
      render: (row) => {
        return (
          <div>
            {Number(row?.productId?.lowest_ask) -
              Number(row?.bidAmount)}
          </div>
        )
      }
    },
    {
      name: "Lowest Ask",
      render: (row) => {
        return (
          <div>
            <button
              onClick={(e) => {
                e.stopPropagation()
                window.open(`/bidask/${row?.productId?.slug}`, "_blank")
              }
              }
              className="btn btn-success p-2 border border-dark"
              style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
            >
              {row?.productId?.lowest_ask && row?.productId?.lowest_ask > 0
                ? "Buy Now - $" + row?.productId?.lowest_ask
                : "Not Found"}
            </button> </div>
        )
      }
    },
    {
      name: "Your Bid",
      render: (row) => {
        return (
          <div>  {row?.bidAmount && row?.bidAmount > 0 ? row?.bidAmount : "NA"}</div>
        )
      }
    },
    {
      name: "Actions",
      render: (row) => {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <span onClick={() => setUpdateBid(row)}>
              <EditSvg />
            </span>
          </div>
        )
      }
    }
  ]

  const editRow = (id) => {
    setSelectedRow(id);
  };
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setdescriptionindex1(); // Close the modal
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleClickOutsideModal = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setdescriptionindex(null);
    }
  };

  useEffect(() => {
    if (descriptionindex !== null) {
      document.addEventListener("mousedown", handleClickOutsideModal);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideModal);
    };
  }, [descriptionindex]);


  const htmlString =
    "<p class='tl_name'><strong>Why batch</strong><p class='inn-text'>If you only want to buy one item but would like to<br/> bid on multiple items to get the best deal this tool<br/> is for you!<p/><br/><strong>How it works</strong><p class='inn-text'>When any item in the batch sells to you, all of <br/> your existing bids on the other items in the batch<br/> will be automatically deactivated. This makes it<br/> safe for you to bid on many items without risking<br/> to purchase more than one item.</p><br/><strong>Instructions</strong><br/><p class='inn-text'><strong>Create Batch</strong><br/>1. Select the items you would like to Batch.<br/>2. Click batch (All selected items will be Batched).<br/><br/><strong>Remove items</strong><br/>1. Select items you would like to remove.<br/>2. Click unbatch (All selected items will be removed from Batch).<br/><br/><strong>Add Batch</strong><br/>1. Select items you would like to add.<br/>2. Click batch (All selected items will be added to Batch).</p>";

  const handleFilters = () => {
    if (!hideBatchStatus && !bidlistStatus) {
      const bidItems = bidData.filter(item => item?.bidStatus == true);
      setBatchData([])
      setAllBidData(bidItems);
    }
    else if (hideBatchStatus && !bidlistStatus) {
      const bidItems = bidData.filter(item => item?.bidStatus == true);
      const onlyBatchItems = bidItems.filter(item => item.batchStatus == true);
      const nonBatchItems = bidItems.filter(item => !item.batchStatus || item.batchStatus == false);
      const finalItems = [...onlyBatchItems, ...nonBatchItems];
      setBatchData(onlyBatchItems)
      setAllBidData(finalItems);
    }
    else if (!hideBatchStatus && bidlistStatus) {
      const bidItems = bidData.filter(item => item?.bidStatus == false);
      setBatchData([])
      setAllBidData(bidItems);
    }
    else if (hideBatchStatus && bidlistStatus) {
      const bidItems = bidData.filter(item => item?.bidStatus == false);
      const onlyBatchItems = bidItems.filter(item => item.batchStatus == true);
      const nonBatchItems = bidItems.filter(item => !item.batchStatus || item.batchStatus == false);
      const finalItems = [...onlyBatchItems, ...nonBatchItems];
      setBatchData(onlyBatchItems)
      setAllBidData(finalItems);
    }
    else {
      setAllBidData(bidData);
    }
  }

  useEffect(() => {
    handleFilters();
  }, [allBidData, hideBatchStatus, bidlistStatus])

  // Update batch count whenever batchData or bidData changes
  useEffect(() => {
    // First try to get count from batchData
    let count = batchData?.length || 0;

    // If batchData is empty but we have bidData, count batch items from bidData
    if (count === 0 && bidData?.length > 0) {
      count = bidData.filter(
        (item) => item.isBatch === true || item.batchStatus === true
      ).length;
    }

    setBatchCount(count || 0);
  }, [batchData, bidData]);

  // Dispatch batch status update event for mobile UI
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('batchStatusUpdate', {
      detail: { hideBatchStatus, batchCount: batchCount || 0 }
    }));
  }, [hideBatchStatus, batchCount]);

  // Function to get the data of the bid list based on a user ID
  const handleGetBidList = (id) => {
    setInitialLoader(true);
    ExportApi.getBidList(id)
      .then((resp) => {
        if (resp.data.status) {
          let data = [...resp.data.activeBids ?? [], ...resp.data.inActiveBids ?? []];
          setAllBidData(data);
          setBidData(data);
          setInitialLoader(false);
        } else {
          toast.error(resp.data.message ?? "Somehing went wrong...");
          setInitialLoader(false);
        }
      })
      .catch((err) => {
        toast.error("Somehing went wrong...")
        console.log(err);
        setInitialLoader(false);
      });

    ExportApi.checkBatchStatus(id)
      .then((resp) => {
        if (resp?.data?.statusCode == 200) {
          setAlreadyCreatedBatch(resp?.data.data.batchStatus);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sortedData = bidData?.sort((a, b) => {
    if (a.batchStatus && !b.batchStatus) {
      return -1;
    }
    if (!a.batchStatus && b.batchStatus) {
      return 1;
    }
    return 0;
  });



  // batch creation
  const handleCreateBatch = () => {
    if (selectedIds?.length == 0) {
      toast.error("Please select products first");
      return;
    }
    setAllLoaders((prev) => ({
      ...prev,
      batching: true
    }));

    const resultArray = allBidData.filter((item) =>
      selectedIds.includes(item._id)
    );

    // const uniqueData = Array.from(
    //   new Set(resultArray.map((item) => item.productId._id))
    // ).map((productId) =>
    //   resultArray.find((item) => item.productId._id === productId)
    // );

    let finalArray = resultArray.map((item) => item.productId._id);

    ExportApi.createBatch(finalArray, loggedInUser?.id, "sell")
      .then((resp) => {
        if (resp.data.status == true) {
          setAllLoaders((prev) => ({
            ...prev,
            batching: false
          }));
          setSelectedIds([]);
          handleGetBidList(loggedInUser?.id);
          // HandleGetFilterListData();
          toast.success(resp.data.message);
        } else {
          setSelectedIds([]);
          setAllLoaders((prev) => ({
            ...prev,
            batching: false
          }));
          // setShowButtonLoader(false);
          handleGetBidList(loggedInUser?.id);
          // HandleGetFilterListData();
          toast.error(resp.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUnBatch = () => {
    if (selectedIds?.length == 0) {
      toast.error("Please Select the Product First");
      return;
    }

    setAllLoaders((prev) => ({ ...prev, unBatching: true }))

    const resultArray = allBidData.filter((item) =>
      selectedIds.includes(item._id)
    );

    let finalArray = resultArray.map((item) => item.productId._id);

    ExportApi.removeFromBatch(finalArray, loggedInUser?.id, "sell")
      .then((resp) => {
        if (resp?.data?.status == true) {
          setAllLoaders((prev) => ({ ...prev, unBatching: false }))

          toast.success(resp?.data?.message);
          setSelectedIds([]);
          handleGetBidList(loggedInUser?.id);
        } else {
          setAllLoaders((prev) => ({ ...prev, unBatching: false }))

          toast.error(resp.data.message);
          setSelectedIds([]);
          handleGetBidList(loggedInUser?.id);
        }
      })
      .catch((err) => {
        setAllLoaders((prev) => ({ ...prev, unBatching: false }))

        toast.error(err);
      });
  }


  //function to show inactive ask
  const handleShowInactiveBidList = () => {
    setBidListStatus(!bidlistStatus);
  };



  // select All Functionlaity for the checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;

    if (checked) {
      const allIds = allBidData.map((item) => item._id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  // Handle item selection
  const handleCheck = (checked, id) => {
    setSelectedIds((prev) => {
      if (checked) {
        // add id
        return [...prev, id];
      } else {
        // remove id
        return prev.filter((itemId) => itemId !== id);
      }
    });
  };



  const handleUpdateBatch = (data, id) => {
    // setLoader(0)
    if (loggedInUser?.id) {
      ExportApi.updateBatch(data, id, loggedInUser?.id).then((resp) => {
        handleGetBidList(loggedInUser?.id);
        HandleGetFilterListData();
        setSelectCheckBox(false);
      });
    }
  };

  //sort data Here
  //key used for the get the name of the variable for sorting
  const sortHere = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = bidData.sort((a, b) => {
      if (a[key] < b[key]) return -1 * sortOrder;
      if (a[key] > b[key]) return sortOrder;
      return 0;
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  const sortProductData = (key) => {
    const sortOrder = key === currentSortKey ? -currentSortOrder : 1;
    const sortedProducts = bidData.sort((a, b) => {

      // return
      if (key == "spread") {
        if (
          a?.productId["lowest_ask"] - a?.productId["highest_bid"] <
          b?.productId["lowest_ask"] - b?.productId["highest_bid"]
        )
          return -1 * sortOrder;
        if (
          a?.productId["lowest_ask"] - a?.productId["highest_bid"] >
          b?.productId["lowest_ask"] - b?.productId["highest_bid"]
        )
          return sortOrder;
        return 0;
      } else {
        if (a?.productId[key] < b?.productId[key]) return -1 * sortOrder;
        if (a?.productId[key] > b?.productId[key]) return sortOrder;
        return 0;
      }
    });
    setCurrentSortKey(key);
    setCurrentSortOrder(sortOrder);
  };

  // Function for filtering bid data based on selected conditions, brands, series, etc.
  // Function to filter data based on various criteria
  const SearchFilterCheck = () => {
    let filterData = allBidData;
    let filteredList = filterData; // Start with the original list
    if (
      condition?.length > 0 ||
      brand?.length > 0 ||
      series?.length > 0 ||
      model?.length > 0 ||
      chipset?.length > 0
    ) {
      if (condition?.length > 0) {
        // Filter by condition
        filteredList = filteredList?.filter((item) =>
          condition.includes(item?.productId.type)
        );
      }
      if (brand?.length > 0) {
        // Filter by brand
        filteredList = filteredList?.filter((item) =>
          brand.includes(item?.productId?.brand)
        );
      }
      if (series?.length > 0) {
        // Filter by series
        filteredList = filteredList?.filter((item) =>
          series.includes(item?.productId?.series)
        );
      }
      if (model?.length > 0) {
        // Filter by model
        filteredList = filteredList?.filter((item) =>
          model.includes(item?.productId?.model)
        );
      }
      if (chipset?.length > 0) {
        // Filter by chipset
        filteredList = filteredList?.filter((item) =>
          chipset.includes(item?.productId?.chipset)
        );
      }
      setAllBidData(filteredList);
    } else {
      if (localStorage.getItem("tokenuser")) {
        handleGetBidList(JSON.parse(localStorage.getItem("tokenuser")).id);
        HandleGetFilterListData();
      } else if (localStorage.getItem("admin")) {
        handleGetBidList(JSON.parse(localStorage.getItem("admin")).id);
        HandleGetFilterListData();
      } else {
        // Handle the case when no filters are applied
      }
    }
  };

  const filterData = () => {
    SearchFilterCheck();
  };

  // Function to get filter-related data
  const HandleGetFilterListData = () => {
    // Fetch filter-related data from an API
    ExportApi.GetFilterData()
      .then((resp) => {
        // Initialize arrays to hold filter-related data
        let chipsetKeyArray = [];
        let conditionKeyArray = [];
        let brandKeyArray = [];
        let modalKeyArray = [];
        let seriesKeyArray = [];

        // Process and prepare data for various filter options
        resp?.data.data?.chipset?.map((val, i) => {
          let key = { [val]: false };
          chipsetKeyArray.push(key);
        });
        setchipsetKey([...chipsetKeyArray]);

        resp?.data.data?.condition?.map((val) => {
          if (val == 1) {
            let key = { ["New-Retail"]: false };
            conditionKeyArray.push(key);
          } else if (val == 2) {
            let key = { ["New-2nd Hand"]: false };
            conditionKeyArray.push(key);
          } else {
            let key = { ["Used"]: false };
            conditionKeyArray.push(key);
          }
        });
        setconditionKey([...conditionKeyArray]);

        resp?.data.data?.series?.map((val) => {
          let key = { [val]: false };
          seriesKeyArray.push(key);
        });
        setseriesKey([...seriesKeyArray]);

        resp?.data.data?.brands?.map((val) => {
          let key = { [val]: false };
          brandKeyArray.push(key);
        });
        setbrandKey([...brandKeyArray]);

        resp?.data.data?.model?.map((val) => {
          let key = { [val]: false };
          modalKeyArray.push(key);
        });
        setmodalKey([...modalKeyArray]);

        // Set the filter-related data in the component's state
        setFilterList(resp?.data?.data);
      })
      .catch((err) => console.log(err));
  };

  // Function to open the filter modal
  const handleFilter = () => {
    // Set the state to show the filter modal
    setShowFilterModal(true);
  };

  // Function to clear all applied filters
  const clearAllFilters = () => {
    // Clear all filter arrays and reset filter-related data
    setmodel([]);
    setseries([]);
    setbrand([]);
    setchipset([]);
    setcondition([]);
    setcondition1([]);

    // Fetch bid list data based on user type (user or admin) and reset filters
    if (localStorage.getItem("tokenuser")) {
      handleGetBidList(JSON.parse(localStorage.getItem("tokenuser")).id);
      HandleGetFilterListData();
    } else if (localStorage.getItem("admin")) {
      handleGetBidList(JSON.parse(localStorage.getItem("admin")).id);
      HandleGetFilterListData();
    } else {
      console.log("No Data Found");
    }
  };

  // Function to close a specific condition filter
  //i used for the indexing
  //name used for the which condition filter is implemented
  const conditionKeyFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the condition filter to be closed
    let index = -1;
    for (let i = 0; i < conditionKey.length; i++) {
      if (Object.keys(conditionKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the condition filter from the arrays and update the UI
    conditionKey[index][name] = false;
    condition1.splice(i, 1);
    condition.splice(i, 1);

    setcondition1([...condition1]);
    setcondition([...condition]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific chipset filter
  //id used for the indexing
  //name used for the which condition filter is implemented
  const ChipsetFilterClose = (id, name) => {
    setSelectCheckBox(false);

    // Find the index of the chipset filter to be closed
    let index = -1;
    for (let i = 0; i < chipsetKey.length; i++) {
      if (Object.keys(chipsetKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the chipset filter from the array and update the UI
    chipsetKey[index][name] = false;
    chipset.splice(id, 1);

    setchipset([...chipset]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific brand filter
  //i used for the indexing
  //name used for the which brand filter is implemented
  const brandFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the brand filter to be closed
    let index = -1;
    for (let i = 0; i < brandKey.length; i++) {
      if (Object.keys(brandKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the brand filter from the array and update the UI
    brandKey[index][name] = false;
    brand.splice(i, 1);

    setbrand([...brand]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific series filter
  //i used for the indexing
  //name used for the which series filter is implemented
  const seriesFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the series filter to be closed
    let index = -1;
    for (let i = 0; i < seriesKey.length; i++) {
      if (Object.keys(seriesKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the series filter from the array and update the UI
    seriesKey[index][name] = false;
    series.splice(i, 1);

    setseries([...series]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to close a specific modal filter
  //i used for the indexing
  //name used for the which modal filter is implemented
  const modalFilterClose = (i, name) => {
    setSelectCheckBox(false);

    // Find the index of the modal filter to be closed
    let index = -1;
    for (let i = 0; i < modalKey.length; i++) {
      if (Object.keys(modalKey[i])[0] == name) {
        index = i;
      }
    }

    // Remove the modal filter from the array and update the UI
    modalKey[index][name] = false;
    model.splice(i, 1);

    setmodel([...model]);

    // Trigger the filter check function
    setTimeout(() => {
      SearchFilterCheck();
    });
  };

  // Function to handle the chipset filter
  //i used for the indexing
  //name used for the which chipset filter is implemented
  const ChipsetFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);

    if (checked || index === -1) {
      // If checked or not found in the array, add it to the chipset filter
      chipset.push(name);
      chipsetKey[i][name] = checked;

      setchipset([...chipset]);
      filterData();
    } else {
      // If unchecked, remove it from the chipset filter
      chipsetKey[i][name] = checked;
      chipset.splice(index, 1);

      setchipset([...chipset]);
      filterData();
    }
  };
  // Function to handle the condition filter
  //i used for the indexing
  //name used for the which condition filter is implemented
  const conditionKeyFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked, min } = e.target;
    let number = parseInt(min);
    let index = condition.indexOf(number);
    let index1 = condition1.indexOf(name);

    if (checked || index === -1 || index1 === -1) {
      // If checked or not found in the array, add it to the condition filter
      condition.push(number);
      condition1.push(name);
      conditionKey[i][name] = checked;

      setcondition([...condition]);
      setcondition1([...condition1]);
      filterData();
    } else {
      // If unchecked, remove it from the condition filter
      conditionKey[i][name] = checked;
      condition.splice(index, 1);
      condition1.splice(index1, 1);

      setcondition([...condition]);
      setcondition1([...condition1]);
      filterData();
    }
  };

  // Function to handle the modal filter
  //i used for the indexing
  //name used for the which modal filter is implemented
  const modalFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = chipset.indexOf(name);

    if (checked) {
      // If checked, add it to the modal filter
      model.push(name);
      modalKey[i][name] = checked;

      setmodel([...model]);
      filterData();

    } else {
      // If unchecked, remove it from the modal filter
      modalKey[i][name] = checked;
      model.splice(index, 1);

      setmodel([...model]);
      filterData();
    }
  };

  // Function to handle series filter
  //i used for the indexing
  //name used for the which series filter is implemented
  const seriesFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = series.indexOf(name);

    if (checked) {
      // If checked, add it to the series filter
      series.push(name);
      seriesKey[i][name] = checked;

      setseries([...series]);
      filterData();
    } else {
      // If unchecked, remove it from the series filter
      seriesKey[i][name] = checked;
      series.splice(index, 1);

      setseries([...series]);
      filterData();
    }
  };
  // Function to handle brand filter
  //i used for the indexing
  //name used for the which brand filter is implemented
  const BrandFilter = (e, i) => {
    setSelectCheckBox(false);
    const { name, checked } = e.target;
    let index = brand.indexOf(name);

    if (checked) {
      // If checked, add it to the brand filter
      brand.push(name);
      brandKey[i][name] = checked;

      setbrand([...brand]);
      filterData();
    } else {
      // If unchecked, remove it from the brand filter
      brandKey[i][name] = checked;
      brand.splice(index, 1);

      setbrand([...brand]);
      filterData();
    }
  };

  // Function to show more or less chipset results
  //data used for to show more or less result
  const handlechipsetshowmore = (data) => {
    if (data == "More") {
      setChipsetShow(true);
    } else {
      setChipsetShow(false);
    }
  };
  // Function to show more or less brand results
  //data used for to show more or less result
  const handlebrandshowmore = (data) => {
    if (data == "More") {
      setBrandShow(true);
    } else {
      setBrandShow(false);
    }
  };
  // Function to show more or less series results
  //data used for to show more or less result
  const handleSeriesshowmore = (data) => {
    if (data == "More") {
      setSeriesShow(true);
    } else {
      setSeriesShow(false);
    }
  };
  // Function to show more or less series results
  //data used for to show more or less result
  const handlemodelshowmore = (data) => {
    if (data == "More") {
      setModelShow(true);
    } else {
      setModelShow(false);
    }
  };


  const handleHideBatch = () => {
    setHideBatchStatus(prev => !prev);
  };

  useEffect(() => {
    handleGetBidList(loggedInUser?.id)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to fetch user data based on user ID for authentication
  //id used for the specific user id
  const handleSingleUserData = (id) => {
    ExportApi.getSingleUserData(id)
      .then((resp) => {
        if (resp.data.message == "user not found") {
          // If the user is not found, dispatch the "Loginout" event
          window.dispatchEvent(new Event("Loginout"));
        } else {
          // Handle the case when user data is found
        }
      })
      .catch((err) => console.log(err));
  };

  // Adding an event listener to the 'window' object for the "Loginout" event
  window.addEventListener("Loginout", () => {
    // This code block is executed when the "Loginout" event is triggered

    // Clear the localStorage (removes user/admin tokens)
    localStorage.clear();

    // Navigate to the root path ("/")
    navigate("/");
  });

  useEffect(() => {
    HandleGetFilterListData();
    handleSingleUserData(loggedInUser.id);
  }, [loggedInUser]);

  useEffect(() => {
    const handleMobileFunction = (e) => {
      const { action } = e.detail;
      if (action === 'delete') handleDeleteProduct();
      if (action === 'makeActive') updateBidsStatus(selectedIds, true);
      if (action === 'makeInactive') updateBidsStatus(selectedIds, false);
      if (action === 'showInactive') handleShowInactiveBidList();
      if (action === 'filter') handleFilter();
      if (action === 'unbatch') handleUnBatch();
      if (action === 'batch') handleCreateBatch();
      if (action === 'showBatch') handleHideBatch();
      // if (action === 'duplicate') duplicateBidList(selectedData, true);

    };

    window.addEventListener('mobileFunction', handleMobileFunction);
    return () => window.removeEventListener('mobileFunction', handleMobileFunction);
  }, [selectedIds]);

  const updateBidsStatus = (selectData, status) => {
    if (selectedIds.length <= 0) {
      toast.error("Please Select a Product First");
      return;
    }
    if (status) {
      setAllLoaders((prev) => ({ ...prev, makeActive: true }));
    }
    else {
      setAllLoaders((prev) => ({ ...prev, makeInactive: true }));
    }

    ExportApi.updateBidList(selectData, status)
      .then((resp) => {
        setAllLoaders((prev) => ({ ...prev, makeInactive: false, makeActive: false }));
        handleGetBidList(JSON.parse(localStorage.getItem("tokenuser"))?.id);
        setSelectedIds([]);
      })
      .catch((err) => {
        setAllLoaders((prev), ({ ...prev, makeInactive: false, makeActive: false }));
        console.log(err);
      });
  }



  //Product Delete
  const handleDeleteProduct = () => {
    if (selectedIds?.length > 0) {

      let confirm = window.confirm("Are you sure you want to delete");
      if (confirm) {
        ExportApi.deleteBuyingTabProduct(selectedIds).then((resp) => {
          if (resp.data) {
            toast.success(resp.data.message);
            handleGetBidList(loggedInUser?.id);
            setSelectedIds([])
          } else {
            toast.error(resp.data.message);
          }
        });
      } else {
        setSelectedIds([])
      }
    } else {
      toast.error("Please Select a Product First");
    }
  };

  const updateExpiration = (fieldValue, id) => {

    setExpiration(fieldValue);
  };

  const updateBidData = (id, expiration) => {
    ExportApi.updateExpiration(id, expiration)
      .then((resp) => {
        if (resp.status == 201) {
          handleGetBidList(loggedInUser?.id);
          setUpdateBid(null)
        } else {
          console.log("error");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const redirectToProductPage = (id, page) => {
    if (page == "product") {
      navigate("/product/" + id);
    } else {
      navigate("/bidask/" + id);
    }
  };

  const [askListOrderBook, setAskListOrderBook] = useState();
  const [bidListOrderBook, setBidListOrderBook] = useState();

  const showOrderBook = (product_id) => {
    ExportApi.showOrderBook(product_id)
      .then((resp) => {

        if (resp?.data.statusCode == 200) {
          setAskListOrderBook(resp?.data.data.askList);
          setBidListOrderBook(resp?.data.data.bidList);
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>

      <style>
        {
          `
          .form-check-input {
          background-color : none !important;
          }

           .form-check-input:checked {
          background-color : #0d6efd !important;
          }
          `
        }
      </style>
      <Row>
        <Col lg={12} className="sm-5 mt-1">
          {/* Desktop Function Buttons - Show only on desktop */}
          {isDesktop && (
            <div className="text-sm-end text-center">
              <Button
                className="bg-none text-black border border-2 mb-2 mb-sm-0 mx-1"
                onClick={handleUnBatch}
              >
                {showUnbatchLoader ? "Please Wait..." : "Unbatch"}
                <ReactTooltip
                  className="custom-tooltip_buy-sell"
                  anchorId="app-batch-buying-tab"
                  place="bottom"
                  clickable={true}
                  closeOnScroll={false}
                  content={
                    <div dangerouslySetInnerHTML={{ __html: htmlString }} />
                  }
                  style={{ textTransform: "none" }}
                />
              </Button>
              <Button
                className="bg-none text-black border border-2 mb-2 mb-sm-0 mx-1"
                onClick={handleCreateBatch}
              >
                {allLoader?.batching ? "Please Wait..." : "Batch"}
                <ReactTooltip
                  className="custom-tooltip_buy-sell"
                  anchorId="app-batch-buying-tab"
                  place="bottom"
                  clickable={true}
                  closeOnScroll={false}
                  content={
                    <div dangerouslySetInnerHTML={{ __html: htmlString }} />
                  }
                  style={{ textTransform: "none" }}
                />
                <QuestionMarkSvg style={{ color: 'black' }} />
              </Button>
              <Button
                className={`border border-2 mb-2 mb-sm-0 mx-1 ${hideBatchStatus ? "bg-success text-white" : "bg-none text-black"
                  }`}
                onClick={handleHideBatch}
              >
                {hideBatchStatus ? `Hide Batch (${batchCount || 0})` : `Show Batch (${batchCount || 0})`}
              </Button>

              <Button
                className="bg-none text-black border border-2 mx-1 mb-2 mb-sm-0"
                onClick={handleDeleteProduct}
              >
                Delete
              </Button>
              <Button
                className="bg-none text-black border border-2 mb-2 mb-sm-0 mx-1"
                onClick={() => updateBidsStatus(selectedIds, true)}
                disabled={!bidlistStatus || allLoader?.makeActive}
              >
                {allLoader?.makeActive ? "Please Wait..." : "Make Active"}
              </Button>
              <Button
                className="bg-none text-black border border-2 mb-2 mb-sm-0 mx-1"
                onClick={() => updateBidsStatus(selectedIds, false)}
                disabled={bidlistStatus || allLoader?.makeInactive}
              >
                {allLoader?.makeInactive ? "Please Wait..." : "Make Inactive"}
                
              </Button>
              <Button
                className={`border border-2 mx-1 mb-2 mb-sm-0 ${bidlistStatus ? "bg-success text-white" : "bg-none text-black"
                  }`}
                onClick={handleShowInactiveBidList}
              >
                Show Inactive
              </Button>
              <Button
                className="bg-none text-black border border-2 mb-2 mb-sm-0 mx-1"
                onClick={handleFilter}
              >
                Filter
              </Button>
            </div>
          )}

          {/* Start Clear All Filter */}
          <div className="text-center text-sm-start">
            {((condition && condition.length > 0) ||
              (chipset && chipset.length > 0) ||
              (brand && brand.length > 0) ||
              (series && series.length > 0) ||
              (model && model.length > 0)) && (
                <>
                  <Button
                    className="clear-all-filters-btn bg-white border text-dark px-4 py-2 fw-bold"
                    onClick={() => clearAllFilters()}
                  >
                    Clear all filters
                  </Button>
                  <div className="filter-chips-grid">
                    {conditionKey.map((val, i) => {
                      let key = condition1[i];
                      let data = conditionKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`condition-${i}`}
                            className="filter-chip-item"
                          >
                            {condition1[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() =>
                                conditionKeyFilterClose(i, condition1[i])
                              }
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {chipsetKey.map((val, i) => {
                      let key = chipset[i];
                      let data = chipsetKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`chipset-${i}`}
                            className="filter-chip-item"
                          >
                            {chipset[i]}
                            <Button
                              className="filter-chip-close"
                              onClick={() => ChipsetFilterClose(i, chipset[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {brandKey?.map((val, i) => {
                      let key = brand[i];
                      let data = brandKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`brand-${i}`}
                            className="filter-chip-item"
                          >
                            {brand[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => brandFilterClose(i, brand[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {seriesKey.map((val, i) => {
                      let key = series[i];
                      let data = seriesKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`series-${i}`}
                            className="filter-chip-item"
                          >
                            {series[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => seriesFilterClose(i, series[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                    {modalKey.map((val, i) => {
                      let key = model[i];
                      let data = modalKey.filter((item) => item[key] == true);
                      return (
                        data.length != 0 ? (
                          <span
                            key={`model-${i}`}
                            className="filter-chip-item"
                          >
                            {model[i]}{" "}
                            <Button
                              className="filter-chip-close"
                              onClick={() => modalFilterClose(i, model[i])}
                            >
                              X
                            </Button>
                          </span>
                        ) : null
                      );
                    })}
                  </div>
                </>
              )}
          </div>
        </Col>
        <Col
          lg={12}
          className="product_list_table table-responsive mt-sm-5 mt-3"
        >
          <SharedTable
            loader={initialLoader}
            columns={columns}
            data={allBidData}
            onRowClick={(row) => {
              setSelectedRowData(row);
            }}
            batch={true}
            batchData={batchData}
            hideBatchStatus={hideBatchStatus}
            isDesktop={isDesktop}
          />

          {loader == 0 ? (
            <div className="loader-icon" style={{ marginBlock: "80px" }}>
              <i className="fa-solid fa-spinner fa-spin-pulse"></i>
            </div>
          ) : loader == 1 ? (
            <Table
              bordered
              striped
              className="align-middle text-center managment-table"
            >
              <thead>
                <tr>
                  {hideBatchStatus && batchData?.length > 0 ? <th></th> : null}
                  <th className="text-start">
                    <Form.Check
                      className="d-inline"
                      type="checkbox"
                      checked={selectCheckBox}
                      onChange={(e) => handleSelectAll(e)}
                    />{" "}
                    <label>Select All</label>
                  </th>
                  <th onClick={() => sortProductData("chipset")}>
                    Chipset{" "}
                    <SortSvg />
                  </th>
                  <th onClick={() => sortProductData("brand")}>
                    Brand{" "}
                    <SortSvg />
                  </th>
                  <th onClick={() => sortProductData("series")}>
                    Series{" "}
                    <SortSvg />
                  </th>
                  <th onClick={() => sortProductData("model")}>
                    Model{" "}
                    <SortSvg />
                  </th>
                  <th onClick={() => sortHere("expirationTime")}>
                    Expiration{" "}
                    <SortSvg />
                  </th>
                  <th onClick={() => sortProductData("spread")}>
                    Spread
                    <ReactTooltip
                      className="custom-tooltip"
                      anchorId={`app-batch-spread-tab`}
                      place="bottom"
                      clickable={true}
                      closeOnScroll={false}
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: "<p>Spread = Lowest Ask - Your Bid</p>",
                          }}
                        />
                      }
                    />

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-chevron-expand"
                      viewBox="0 0 16 16"
                    >
                      <path
                        filerule="evenodd"
                        d="M3.646 9.146a.5.5 0 0 1 .708 0L8 12.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708zm0-2.292a.5.5 0 0 0 .708 0L8 3.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708z"
                      ></path>
                    </svg>
                  </th>
                  <th onClick={() => sortProductData("lowest_ask")}>
                    Lowest Ask{" "}
                    <SortSvg />
                  </th>


                  <th onClick={() => sortHere("bidAmount")}>
                    Your Bid
                    <SortSvg />
                  </th>

                  <th onClick={() => sortHere("bidAmount")}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {bidData?.length > 0 ? (
                  bidData?.map((val, i) => {
                    return (
                      <tr>
                        {hideBatchStatus && val.batchStatus ? (
                          i === 0 ? (
                            <td
                              rowSpan={batchData?.length}
                              className="fst-part-cont"
                              style={!isDesktop ? { minWidth: 0, } : null}
                            >
                              <div
                                className={`bg-dark ${!isDesktop ? "" : ""} text-white mr-1 d-flex align-items-center`}>
                                <p className="vertical-text">BATCH</p>
                              </div>
                            </td>
                          ) : null
                        ) : null}


                        <td>
                          <div className="d-flex align-items-end justify-content-between">
                            <Form.Check
                              className="d-inline"
                              type="checkbox"
                              checked={val?.isSelected}
                              onChange={(e) =>
                                handleCheck(e.target.checked, val?._id)
                              }
                            />
                            <div style={{ width: "100px", height: "90px" }}>
                              <img
                                // src={`${imageUrl}${val?.productId?.image[0]}`}
                                src={
                                  val?.productId?.image[0]?.startsWith("http")
                                    ? val?.productId?.image[0]
                                    : `${imageUrl}${val?.productId?.image[0]}`
                                }
                                style={{ width: "100%", height: "100%" }}
                                onClick={() =>
                                  navigate(
                                    `/product/${val?.productId?.slug}`
                                  )
                                }
                              />
                            </div>
                            <div class="position-relative ms-1">
                              <span className="d-block text-center">
                                {val.productId?.type == 1
                                  ? "New"
                                  : val.productId?.type == 2
                                    ? "New(Resale)"
                                    : "Used(Tested)"}
                              </span>

                              {val.productId?.description != "" && (
                                <>
                                  {descriptionindex === i ? (
                                    <Button
                                      className="bg-none border-0"
                                      onClick={() => setdescriptionindex()}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#0000ff"
                                        className="bi bi-chevron-down"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          filerule="evenodd"
                                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                        />
                                      </svg>
                                    </Button>
                                  ) : (
                                    <Button
                                      className="bg-none border-0"
                                      onClick={() => setdescriptionindex(i)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="#0000ff"
                                        className="bi bi-chevron-down"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          filerule="evenodd"
                                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                        />
                                      </svg>
                                    </Button>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div>
                            {descriptionindex == i ? (
                              <div className="modal_custom_buyp new_modal_drop">
                                <div
                                  className="inner_customModal_one"
                                  ref={modalRef}
                                >
                                  <h6
                                    dangerouslySetInnerHTML={{
                                      __html: val?.productId?.description,
                                    }}
                                  ></h6>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </td>

                        <td
                          style={{
                            cursor: "default",
                          }}
                        >
                          {val?.productId?.chipset}
                        </td>
                        <td
                          style={{
                            cursor: "default",
                          }}
                        >
                          {val?.productId?.brand}
                        </td>
                        <td
                          style={{
                            cursor: "default",
                          }}
                        >
                          {val?.productId?.series}
                        </td>
                        <td
                          style={{
                            maxWidth: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            cursor: "default",
                          }}
                          title={val?.productId?.model}
                        >
                          {val?.productId?.model}
                        </td>
                        <td>
                          <div className="d-flex flex-column edit">
                            {val?._id == selectedRow ? (
                              <span
                                onClick={() =>
                                  updateBidData(
                                    val._id,
                                    !expiration ? val?.expiration : expiration
                                  )
                                }
                              >
                                Save
                              </span>
                            ) : (
                              <span onClick={() => editRow(val._id)}>
                                <EditSvg />
                              </span>
                            )}
                            <input
                              type="number"
                              className="table-qty"
                              placeholder={`${val?.expirationTime ? val?.expirationTime : "0"
                                } Days`}
                              value={
                                getRemainingDays(val?.createdAt, val?.expirationTime)
                              }
                              onChange={(e) => {
                                const newExpirationTime = parseInt(
                                  e.target.value
                                );
                                updateExpiration(newExpirationTime, val?._id);
                              }}
                              disabled={val?._id == selectedRow ? false : true}
                            />
                          </div>
                        </td>
                        <td>
                          {val?.productId?.lowest_ask -
                            val?.productId?.highest_bid}
                        </td>
                        <td>
                          <button
                            onClick={() =>
                              redirectToProductPage(
                                val?.productId?.slug,
                                "product"
                              )
                            }
                            className="btn btn-success p-2 border border-dark"
                            style={{ backgroundColor: "#225e40", borderRadius: "50px", padding: "6px 16px" }}
                          >
                            {val?.productId?.lowest_ask
                              ? "Buy Now - $" + val?.productId?.lowest_ask
                              : "Not Found"}
                          </button>
                        </td>
                        <td

                        >
                          <Link
                            to={`/bidask/${val?.productId?.slug}`}
                            state={{
                              bidamount: val?.bidAmount,
                              bidId: val?._id,
                            }}
                          >

                            <span

                              className={`border border-dark p-1 rounded-1 ask buy_ask ${val?.productId?.YourHighestBid
                                ? "show-green"
                                : ""
                                }`}
                            >
                              {val?.bidAmount ? val?.bidAmount : "Not Found"}
                            </span>
                          </Link>
                          <span className="position-relative buy-arrow-btn">
                            {descriptionindex1 == i ? (
                              <span
                                className=""
                                onClick={() => {
                                  setdescriptionindex1();
                                  setAskListOrderBook();
                                  setBidListOrderBook();
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#0000ff"
                                  className="bi bi-chevron-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    filerule="evenodd"
                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                  />
                                </svg>
                              </span>
                            ) : (
                              <span
                                className=""
                                onClick={() => {
                                  showOrderBook(val?.productId._id);
                                  setdescriptionindex1(i);
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#0000ff"
                                  className="bi bi-chevron-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    filerule="evenodd"
                                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
                                  />
                                </svg>
                              </span>
                            )}

                            {descriptionindex1 == i ? (
                              <div className="buy_table_modal">
                                <div className="inner_customModal_two" ref={modalRef}>
                                  <div
                                    class="inner_customModal"
                                    id="bid_ask_model"
                                    style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', width: '100%' }}
                                  >
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <div class="table-responsive-sm thin-scrollbar" style={{ overflowY: 'auto', overflowX: 'auto', position: 'relative', scrollbarWidth: 'thin' }}>
                                        <table class="table table-striped table-bordered table-hover" style={{ marginBottom: 0, fontSize: '12px', width: '100%' }}>
                                          <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#fff' }}>
                                            <tr>
                                              <th style={{ padding: '8px', fontSize: '12px', whiteSpace: 'nowrap', minWidth: '60px', width: '60px', position: 'sticky', left: 0, zIndex: 11, backgroundColor: '#fff', boxShadow: '2px 0 4px -2px rgba(0,0,0,0.1)' }}>Qty</th>
                                              <th style={{ padding: '8px', fontSize: '12px', whiteSpace: 'nowrap', minWidth: '60px', width: '60px' }}>Bid</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {bidListOrderBook?.length > 0 ? (
                                              bidListOrderBook?.map((item, idx) => (
                                                <tr key={idx}>
                                                  <td style={{ padding: '6px 8px', minWidth: '60px', width: '60px', position: 'sticky', left: 0, zIndex: 1, backgroundColor: idx % 2 === 0 ? '#fff' : 'rgba(0,0,0,0.05)' }}>{item?.quantity}</td>
                                                  <td style={{ padding: '6px 8px', minWidth: '60px', width: '60px' }}> ${item?.bidAmount}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr><td colSpan="2" style={{ padding: '6px 8px', textAlign: 'center' }}>No data found</td></tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                      <div class="table-responsive-sm thin-scrollbar" style={{ overflowY: 'auto', overflowX: 'auto', position: 'relative', scrollbarWidth: 'thin' }}>
                                        <table class="table table-striped table-bordered table-hover" style={{ marginBottom: 0, fontSize: '12px', width: '100%' }}>
                                          <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#fff' }}>
                                            <tr>
                                              <th style={{ padding: '8px', fontSize: '12px', whiteSpace: 'nowrap', minWidth: '60px', width: '60px', position: 'sticky', left: 0, zIndex: 11, backgroundColor: '#fff', boxShadow: '2px 0 4px -2px rgba(0,0,0,0.1)' }}>Qty</th>
                                              <th style={{ padding: '8px', fontSize: '12px', whiteSpace: 'nowrap', minWidth: '60px', width: '60px' }}>Ask</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {askListOrderBook?.length > 0 ? (
                                              askListOrderBook?.map((item, idx) => (
                                                <tr key={idx}>
                                                  <td style={{ padding: '6px 8px', minWidth: '60px', width: '60px', position: 'sticky', left: 0, zIndex: 1, backgroundColor: idx % 2 === 0 ? '#fff' : 'rgba(0,0,0,0.05)' }}>{item?.quantity}</td>
                                                  <td style={{ padding: '6px 8px', minWidth: '60px', width: '60px' }}> ${item?.askAmount}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr><td colSpan="2" style={{ padding: '6px 8px', textAlign: 'center' }}>No data found</td></tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                          </span>

                        </td>
                        <td
                        >
                          <span onClick={() => setUpdateBid(val)}>
                            <EditSvg />
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <span>No Data Found</span>
                )}
              </tbody>
              <br></br>
              <br></br>
            </Table>
          ) : (
            <Table
              bordered
              striped
              className="align-middle text-center managment-table"
            >
              <tbody>
                <tr>No Data Found</tr>
              </tbody>
            </Table>
          )}
        </Col>
      </Row>

      {/* Start filter Modal */}
      <Modal
        className="custom-mode"
        contentClassName="custom-modal-content"
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Product Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scrollable-modal-body">
          <div className="border mb-sm-5">
            <div className="sidebar-accordian p-3">
              <div>
                <span>
                  <b>Condition</b>
                </span>
                {FilterList?.condition?.map((val, i) => {
                  return (
                    <Form.Group className="mb-2" controlId={val} key={i}>
                      <Form.Check
                        type="checkbox"
                        checked={
                          conditionKey[i][
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New(Resale)"
                              : "Used(Tested)"
                          ]
                        }
                        onChange={(e) => conditionKeyFilter(e, i)}
                        name={
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New(Resale)"
                              : "Used(Tested)"
                        }
                        min={val}
                        label={
                          val == 1
                            ? "New-Retail"
                            : val == 2
                              ? "New(Resale)"
                              : "Used(Tested)"
                        }
                      />
                    </Form.Group>
                  );
                })}
                {conditionKey?.length > 6 ? (
                  <Button className="bg-none mb-3 border-0 p-0 text-dark">
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Chipset</b>
                </span>
                {chipsetShow
                  ? FilterList?.chipset?.map((val, i) => {
                    return (
                      <>
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={chipsetKey[i][val]}
                            onChange={(e) => ChipsetFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      </>
                    );
                  })
                  : FilterList?.chipset?.map((val, i) => {
                    return (
                      <>
                        {i < 6 ? (
                          <Form.Group
                            className="mb-2"
                            controlId={val}
                            key={i}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={chipsetKey[i][val]}
                              onChange={(e) => ChipsetFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        ) : null}
                      </>
                    );
                  })}
                {chipsetShow ? (
                  FilterList?.chipset?.length > 6 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlechipsetshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.chipset?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlechipsetshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Brand</b>
                </span>
                {brandShow
                  ? FilterList?.brands?.map((val, i) => {
                    return (
                      <>
                        <Form.Group className="mb-2" controlId={val} key={i}>
                          <Form.Check
                            type="checkbox"
                            checked={brandKey[i][val]}
                            onChange={(e) => BrandFilter(e, i)}
                            name={val}
                            label={val}
                          />
                        </Form.Group>
                      </>
                    );
                  })
                  : FilterList?.brands?.map((val, i) => {
                    return (
                      <>
                        {i < 6 ? (
                          <Form.Group
                            className="mb-2"
                            controlId={val}
                            key={i}
                          >
                            <Form.Check
                              type="checkbox"
                              checked={brandKey[i][val]}
                              onChange={(e) => BrandFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        ) : null}
                      </>
                    );
                  })}
                {brandShow ? (
                  FilterList?.brands?.length > 6 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlebrandshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.brands?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlebrandshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Series</b>
                </span>
                {seriesShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.series?.map((val, i) => {
                      return (
                        <>
                          <Form.Group className="mb-2" controlId={val} key={i}>
                            <Form.Check
                              type="checkbox"
                              checked={seriesKey[i][val]}
                              onChange={(e) => seriesFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.series?.map((val, i) => {
                      return (
                        <>
                          {i < 6 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={seriesKey[i][val]}
                                onChange={(e) => seriesFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                  </div>
                )}
                {seriesShow ? (
                  FilterList?.series?.length > 10 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handleSeriesshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.series?.length > 3 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handleSeriesshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>

              <div>
                <span>
                  <b>Model</b>
                </span>
                {modelShow ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    {FilterList?.model?.map((val, i) => {
                      return (
                        <>
                          <Form.Group className="mb-2" controlId={val} key={i}>
                            <Form.Check
                              type="checkbox"
                              checked={modalKey[i][val]}
                              onChange={(e) => modalFilter(e, i)}
                              name={val}
                              label={val}
                            />
                          </Form.Group>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    {FilterList?.model?.map((val, i) => {
                      return (
                        <>
                          {i < 6 ? (
                            <Form.Group
                              className="mb-2"
                              controlId={val}
                              key={i}
                            >
                              <Form.Check
                                type="checkbox"
                                checked={modalKey[i][val]}
                                onChange={(e) => modalFilter(e, i)}
                                name={val}
                                label={val}
                              />
                            </Form.Group>
                          ) : null}
                        </>
                      );
                    })}
                  </div>
                )}
                {modelShow ? (
                  FilterList?.model?.length > 6 ? (
                    <Button
                      className="bg-none mb-3 border-0 p-0 text-dark"
                      onClick={() => handlemodelshowmore("Less")}
                    >
                      <span className="d-inline me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-plus-square-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm2.5 7.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1" />
                        </svg>
                      </span>{" "}
                      Show Less
                    </Button>
                  ) : null
                ) : FilterList?.model?.length > 6 ? (
                  <Button
                    className="bg-none mb-3 border-0 p-0 text-dark"
                    onClick={() => handlemodelshowmore("More")}
                  >
                    <span className="d-inline me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z" />
                      </svg>
                    </span>{" "}
                    Show More
                  </Button>
                ) : null}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <CustomModal
        show={updateBid !== null}
        handleClose={() => setUpdateBid(null)}
        headerText="Update Bid"
        actionButtonText="Update"
        closeButtonText="Close"
        actionButton={() =>
          updateBidData(
            updateBid._id,
            updateBid?.expirationTime
          )}>
        <form>
          <div className="row g-3 align-items-center">
            {/* Bid Amount */}
            <div className="col-12 col-md-6 d-flex align-items-center">
              <label className="form-label mb-0 flex-shrink-0 me-2"><strong>Bid Amount:</strong></label>
              <input
                type="number"
                className="form-control flex-grow-1"
                value={updateBid?.bidAmount || ""}
                disabled
              />
            </div>

            <div className="col-12 col-md-6 d-flex align-items-center">
              <label className="form-label mb-0 flex-shrink-0 me-2"><strong>Expiration Time:</strong></label>
              <select
                className="form-select flex-grow-1"
                value={updateBid?.expirationTime || ""}
                onChange={(e) => {
                  const newExpirationTime = parseInt(e.target.value);
                  setUpdateBid((prev) => ({
                    ...prev,
                    expirationTime: newExpirationTime,
                  }));
                }}
                disabled={getRemainingDays(updateBid?.createdAt, updateBid?.expirationTime) <= 0 ? true : false}
              >
                <option value="" disabled>Select days</option>
                {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
                  <option key={day} value={day}>{day}</option>
                ))}
              </select>
            </div>

            {getRemainingDays(updateBid?.createdAt, updateBid?.expirationTime) <= 0 && (
              <small className="text-danger mt-1">
                This bid has expired. So this can't be updated.
              </small>
            )}
          </div>
        </form>
      </CustomModal>

      <SharedOffcanvas
        show={selectedRowData !== null}
        title={"Product Description"}
        handleClose={() => setSelectedRowData(null)}
        data={selectedRowData}
      />
      <ToastContainer />
    </div>
  );
}
